// extracted by mini-css-extract-plugin
export var active = "_bq-2";
export var highlight = "_bq-1";
export var highlightLayer = "_bq-0";
export var issuePopover = "_bq-3";
export var statusIcon = "_bq-4";